"use client";

import { ClientRouteErrorFallback } from "@shared/components/client-route-error-fallback";

interface MarketingLocaleErrorProps {
	error: Error & { digest?: string };
	reset: () => void;
}

export default function MarketingLocaleError({
	error,
	reset,
}: MarketingLocaleErrorProps) {
	return <ClientRouteErrorFallback error={error} reset={reset} />;
}
